import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import './alert.scss';

export const Alert = ({ children, type, className, scrollIntoView }) => {
	const instanceRef = useRef(null);

	useEffect(() => {
		if (instanceRef.current && scrollIntoView) {
			scrollToElement(instanceRef.current, { offset: -16 });
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div
			className={classnames('ss-alert', type, className)}
			ref={instanceRef}
		>
			{children}
		</div>
	);
};

Alert.propTypes = {
	children: PropTypes.node,
	type: PropTypes.oneOf(['warning', 'success']),
	scrollIntoView: PropTypes.bool,
	className: PropTypes.string,
};

export default Alert;
